// @flow

import * as React from 'react';


// Subclass this component for creating live-updated components, based on current time in seconds.
// Just use this.state.lastFullSecondTimestamp in your component's rendering then.
// Don't forget to call super in your overridden componentWill* methods.


export type LiveComponentState = {
    lastFullSecondTimestamp?: number,
};


export default class LiveComponent<P: {}, S: LiveComponentState> extends React.Component<P, S> {
    interval: number;

    constructor() {
        super();
        this.updateState();
    }

    updateState() {
        const lastFullSecondTimestamp = 1000 * Math.floor(0.001 * new Date());
        this.setState({ lastFullSecondTimestamp });
    }

    componentWillReceiveProps(newProps: P) {
        this.updateState();
    }

    componentWillMount() {
        this.setupInterval();
    }

    componentWillUnmount() {
        this.clearInterval();
    }

    setupInterval() {
        clearInterval();
        this.interval = setInterval(() => this.updateState(), 500);
    }

    clearInterval() {
        if (this.interval) clearInterval(this.interval);
        delete this.interval;
    }
}


// WEBPACK FOOTER //
// ./src/Reengagement/LiveComponent.jsx